import React, { useState } from "react";
import Dialog from '@material-ui/core/Dialog';
import {
    Box, Button, DialogContent, DialogActions, InputBase, ListItem, ListItemText, CircularProgress
} from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { Search, Close } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core';
import SubItem from '../users/subItemLevel';
import { grey } from '@material-ui/core/colors';
import Checkbox from '../checkbox';
import CustomSwitch from '../CustomizedUIs/GreenSwitch';
import icSearch from '../assets/icons/grayscale-3-search.png';
import { formatperent } from '../dashboard/Dashboard';

const useStyles = makeStyles(theme => ({
    dialog: {
        width: 573,
        borderRadius: 10,
        backgroundColor: '#f3f7fa'
    },
    dialogCloseBtn: {
        border: 'solid 2px #e5f1f8',
        backgroundColor: ' #ffffff',
        marginLeft: 10
    },
    dialogContent: {
        paddingLeft: 32,
        paddingRight: 35
    },
    levelItem: {
        height: '45px',
        paddingLeft: '4rem'
    },
    expandGroup: {
        width: 150,
        height: 30,
        float: 'right',
        borderRadius: '4px',
        backgroundColor: ' #ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    expandText: {
        fontSize: 10,
        fontWeight: 'bold',
        color: grey[500]
    },
    dialogPaper: {

        minHeight: '90vh',
        maxHeight: '90vh',
        backgroundColor: theme.palette.background.default
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        position: 'absolute',
        bottom: 0,
        right: 0,
    }, btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    }, btnExpand: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#88898c',
        padding: '5px'
    }, TitleChangeLeve: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    }, borderSearch: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: '#ffffff',
    },
    inputSearch: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        paddingLeft: '10px',
        color: '#88898c',
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    btnClose: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
    }, TextCluster: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2,
        letterSpacing: '0.12px',
        color: '#4f5064',
    }
}));

const EntityItem = ({ entity, onChangeNode, onToggleExpand }) => {
    const { groups, hide } = entity;

    if (hide) return null;
    return (
        <SubItem data={entity} onChangeNode={onChangeNode} onToggleExpand={onToggleExpand}>
            {
                groups.map((group, index) => <GroupItem
                    group={group}
                    key={index}
                    onChangeNode={onChangeNode}
                    onToggleExpand={onToggleExpand}
                />)
            }
        </SubItem>
    )
}

const GroupItem = ({ group, onChangeNode, onToggleExpand }) => {
    const { clusters, hide } = group;

    if (hide) return null;
    return (
        <SubItem data={group} onChangeNode={onChangeNode} onToggleExpand={onToggleExpand}>
            {clusters.map((cluster, index) => <LevelItem cluster={cluster} key={index} onChangeNode={onChangeNode} />)}
        </SubItem>
    )
}

const LevelItem = ({ cluster, onChangeNode }) => {
    const { name, checked, hide } = cluster;
    const classes = useStyles();
    const changeSelected = () => {
        onChangeNode(cluster);
    }

    if (hide) return null;
    return (
        <Box>
            <ListItem className={classes.levelItem} divider>
                <ListItemText primary={<Typography className={classes.TextCluster}>{name}</Typography>} />
                <Checkbox checked={checked} onChange={changeSelected} />
            </ListItem>
        </Box >
    )
}

const convertTimeSpan = (diff) => {
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    diff -= days * (1000 * 60 * 60 * 24);
    days = days < 1 ? '' : days + ` ${days > 1 ? 'days' : 'day'}`

    var hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * (1000 * 60 * 60);
    hours = hours < 1 ? '' : hours + ` ${hours > 1 ? 'hours' : 'hour'}`

    var mins = Math.floor(diff / (1000 * 60));
    diff -= mins * (1000 * 60);
    mins = mins < 1 ? '' : mins + ` ${mins > 1 ? 'mins' : 'min'}`

    var seconds = Math.floor(diff / (1000));
    diff -= seconds * (1000);
    seconds = seconds + ` ${seconds > 1 ? 'seconds' : 'second'}`
    return {
        days,
        hours,
        mins,
        seconds
    }
}

const ClusterFilter = ({ hideSearch, entities, setEntities, setClusters, setLanguages, setOpenFilter,
    setInfopages, setUsers, setTimeServer, setTimeChannels, setTvUsage, setTvLoading }) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const [filter, setFilter] = useState("");
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );


    const mapCheckedEntities = (node) => {
        const newEntities = entities.map(item => item);

        node.checked = !node.checked;
        node.groups = node.groups.map(group => {
            const clusters = group.clusters.map(cluster => {
                return {
                    ...cluster,
                    checked: node.checked,
                    hide: false,

                };
            });
            return {
                ...group,
                clusters,
                checked: node.checked,
                hide: false,

            };
        });

        newEntities[node.entityIdx] = node;
        return newEntities;
    }

    /** 
     * Description: Check if all clusters is checked
     * RETURN: Boolean
    */
    const shouldEntityChecked = (entity) => {
        for (let groupIdx = 0; groupIdx < entity.groups.length; groupIdx++) {
            const group = entity.groups[groupIdx];
            for (let clusterIdx = 0; clusterIdx < group.clusters.length; clusterIdx++) {
                const cluster = group.clusters[clusterIdx];
                if (!cluster.checked) return false;
            }
        }
        return true;
    }

    const shouldGroupChecked = (group) => {
        for (let clusterIdx = 0; clusterIdx < group.clusters.length; clusterIdx++) {
            const cluster = group.clusters[clusterIdx];
            if (!cluster.checked) return false;
        }
        return true;
    }
    const checkHideClusters = (value) => {

        entities = entities.map(entity => {
            const ents = entity.groups.filter(group => {
                const groups = group.clusters.filter(c => {
                    if (!c.name.toLowerCase().includes(value.toLowerCase().trim())) {
                        c.hide = true
                    } else {
                        c.hide = false;
                        return c;
                    }
                    if (group.name.toLowerCase().includes(value.toLowerCase()) || entity.name.toLowerCase().includes(value.toLowerCase()) || value === '') {
                        c.hide = false;
                        return c;
                    }
                });
                if (!group.name.toLowerCase().includes(value.toLowerCase()) && groups.length === 0) {
                    group.hide = true;
                }
                else if (groups.length > 0 || value === '') {
                    group.hide = false;
                    group.expand = value !== '';
                    return group;
                }
            });
            if (!entity.name.toLowerCase().includes(value.toLowerCase()) && ents.length === 0) {
                entity.hide = true;
            } else {
                entity.hide = false;
                entity.expand = value !== '';
            }
            if (value === '') { entity.hide = false; }
            return entity;
        });
    }

    const mapCheckedGroups = (node) => {
        const newEntities = entities.map(item => item);

        node.checked = !node.checked;
        node.clusters = node.clusters.map(cluster => {
            return {
                ...cluster,
                checked: node.checked,

            };
        });
        newEntities[node.entityIdx][node.groupIdx] = node;
        newEntities[node.entityIdx].checked = shouldEntityChecked(newEntities[node.entityIdx]);

        return newEntities;
    }

    const mapCheckedClusters = (node) => {
        const newEntities = entities.map(item => item);

        const entity = newEntities[node.entityIdx];
        const group = entity.groups[node.groupIdx];

        node.checked = !node.checked;
        group.checked = shouldGroupChecked(group);
        entity.groups[node.groupIdx] = group;

        entity.checked = shouldEntityChecked(entity);
        newEntities[node.entityIdx] = entity;
        return newEntities;
    }


    const searchOnChange = (e) => {
        setFilter(e.target.value);
        checkHideClusters(e.target.value);
        // filterLevel();

    }
    const onChangeNode = (node) => {
        let newEntities;
        switch (node.nodeType) {
            case 'entity':
                newEntities = mapCheckedEntities(node);
                break;
            case 'group':
                newEntities = mapCheckedGroups(node);
                break;
            default:
                newEntities = mapCheckedClusters(node);
                break;
        }
        setEntities(newEntities);
    }

    const onToggleExpand = (node) => {
        node.expand = !node.expand;
        // const newEntities = entities[node]
        const newEntities = entities.map(item => item);
        if (node.nodeType === 'entity') {
            newEntities[node.entityIdx] = node;
        } else {
            newEntities[node.entityIdx].groups[node.groupIdx] = node;
        }
        setEntities(newEntities);
    }

    const formatperenttoarray = (array) => {
        var tempdiff = 0
        var total = 0
        array.forEach(item => total += item[1])
        array.map(item => {
            item[1] = (item[1] / total) * 100
            tempdiff += Math.floor(item[1])
            return item
        })
        var diff = 100 - tempdiff
        array.sort(function (a, b) { return (b[1] - Math.floor(b[1])) - (a[1] - Math.floor(a[1])) })
        return array.map(item => {
            if (diff > 0) {
                item[1] = Math.floor(item[1]) + 1
                diff--
            }
            else
                item[1] = Math.floor(item[1])
            return item
        })
    }

    const getLanguage = (clusterIds) => {
        dataProvider('GET_LIST', "info-language-count", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            let total = 0
            let temps = []
            data.forEach(item => {
                temps.push([item.name, item.count])
            })

            //setLanguageTotal(total)
            setLanguages(formatperenttoarray(temps))

            // setLoading(false);
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
        });
    }

    const getTvUsage = (clusterIds) => {
        setTvLoading(true)
        dataProvider('GET_LIST', "usage-data/get-tv-summarize", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            if (data.length === 0)
                setTvUsage(null)
            else {
                let arrayData = data.detail
                arrayData.splice(0, 1)
                setTvUsage(formatperent(arrayData))

            }
            setTvLoading(false);
        }).catch(error => {
            setTvUsage(null)
            // setError(error);
            setTvLoading(false);
        });
    }

    const getMessageAlarm = (clusterIds) => {
        dataProvider('GET_LIST', "usage-data/get-message-alarm", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            setUsers(data)
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
        });
    }

    const getSelectionMenu = (clusterIds) => {
        dataProvider('GET_LIST', "usage-data/get-menu-selection", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            data.map(item => {
                item.checked = true
                if (item.menu.length > 0)
                    item.menu = formatperenttoarray(item.menu)
                return item
            })
            setInfopages(data)
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
        });
    }

    const getTimeServer = () => {
        dataProvider('GET_LIST', "usage-data/get-server-downup-time", {
            filter: {
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            if (data.length > 0)
                setTimeServer({
                    upTime: convertTimeSpan(data[1]),
                    downTime: convertTimeSpan(data[0] - data[1])
                })
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
        });
    }

    const getTimeView = (clusterIds) => {
        dataProvider('GET_LIST', "usage-data/get-time-view-ic", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            var temps = formatperenttoarray(data)
            setTimeChannels(temps)
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
        });
    }

    const getUsageData = () => {
        let requests = []
        let clusterIds = []
        let clusters = []
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    clusters.push(cluster)
                    cluster.checked && clusterIds.push(cluster.id)
                })
            })
        })
        setClusters(clusters)
        getTvUsage(clusterIds)
        getTimeView(clusterIds)
        getLanguage(clusterIds)
        getMessageAlarm(clusterIds)
        getSelectionMenu(clusterIds)
        getTimeServer()
    }

    const onFilter = () => {
        getUsageData()
        setOpenFilter(false)
    }

    return (
        <Box width='100%' px={1}>

            {!hideSearch &&
                <Box mt={2.25} display="flex" justifyContent='space-between' alignItems='center'>
                    <Box display='flex' alignItems='center' px={1} className={classes.borderSearch} style={{ width: "236px", height: "38px" }}  >
                        < img src={icSearch} width={17.6} height={17.6} style={{ marginLeft: '10.7px' }}></img>
                        <InputBase
                            fullWidth={true}
                            placeholder={translate(`pos.user.searchcluster`)}
                            inputProps={{
                                'aria-label': 'search',
                                className: classes.inputSearch
                            }}
                            onChange={searchOnChange}
                        />
                    </Box>
                    <Box>
                        <Box width='100%' display='flex' justifyContent='flex-end' my={2}>
                            <Button
                                style={{ maxWidth: 40, marginRight: 20 }}
                                onClick={onFilter}
                                variant="contained" color='primary' size='large'>
                                {translate('pos.common.filter')}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            }
            <Box style={{ maxHeight: "70vh", overflow: 'auto' }}>

                {
                    entities.map((entity, index) => <EntityItem
                        entity={entity}
                        key={index}
                        onChangeNode={onChangeNode}
                        onToggleExpand={onToggleExpand}
                    />)
                }

            </Box>
        </Box>


    );
}
export default ClusterFilter